import invariant from '../../lib/invariant';
import AsyncData from '../AsyncData';
export const asyncDataInvariant = asyncData => invariant(asyncData instanceof AsyncData, 'Expected an `AsyncData` not a `%s`', typeof asyncData);